var onlyWarnInDevelopmentMode = function onlyWarnInDevelopmentMode(func) {
  try {
    if (process.env.NODE_ENV === 'development') {
      return func();
    }
  } catch (error) {
    console.error(error);
  }
};
var developmentLog = function developmentLog(message, type, enable) {
  if (type === void 0) {
    type = 'warn';
  }
  if (enable === void 0) {
    enable = false;
  }
  if (enable) {
    console.group('propWarnings');
    console[type](message);
    console.log('💅 This is a development-only message. It will be removed in production.');
    console.groupEnd();
  }
};
var warnOnFieldProps = function warnOnFieldProps(fieldProps) {
  if (fieldProps === void 0) {
    fieldProps = {};
  }
  var propsThatCanBePassedToFieldProps = ['className'];
  Object.keys(fieldProps).forEach(function (prop) {
    if (!propsThatCanBePassedToFieldProps.includes(prop)) {
      developmentLog("Passing a prop named '" + prop + "' to the fieldProps should only be if you want it to live on the Field-module__field DOM element");
    }
  });
};
var warnOfDeprecation = function warnOfDeprecation(props) {
  if (props === void 0) {
    props = {};
  }
  if (props['formFieldClassName']) {
    developmentLog('Passing a prop named \'formFieldClassName\' should be passed as a fieldProp={{ className: yourClassNameHere }} instead');
  }
};

export { developmentLog, onlyWarnInDevelopmentMode, warnOfDeprecation, warnOnFieldProps };
//# sourceMappingURL=propWarnings.js.map
